/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 22/07/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import TextField from "../ui/TextField";
import Autocomplete from "../ui/Autocomplete";
import React from "react";


const AutoCompleteTools = ({
  label,
  name,
  data,
  options,
  disabled,
  onChange,
  maxLength,
  required,
  width,
  error,
  helperText,
}) => {
  // Puede venir como:
  // 1) data[name] = "TEXTO"
  // 2) data[name] = { value: "TEXTO", error, helper }
  const rawField = data?.[name];
  const valorActual =
    rawField && typeof rawField === "object" && "value" in rawField
      ? rawField.value
      : rawField ?? "";

  // Buscamos si hay opción que coincida con el valor actual
  const currentOption =
    options?.find((opt) => {
      const optValue =
        typeof opt === "string" ? opt : opt?.[name];
      return optValue === valorActual;
    }) || null;

  return (
    <Autocomplete
      freeSolo
      disableClearable
      noOptionsText="Sin resultados"
      options={options}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : option?.[name] || ""
      }
      // Si encontramos opción, la usamos; si no, usamos el string directo
      value={currentOption || (valorActual || "")}
      onChange={(event, newValue) => {
        let valor = "";

        if (typeof newValue === "string") {
          valor = newValue;
        } else if (newValue && typeof newValue === "object") {
          // opción normal: { id, presentación } o similar
          valor = newValue[name] ?? newValue.value ?? "";
        }

        // El padre decide si guarda como string simple o dentro de .value
        onChange && onChange(event, valor, name);
      }}
      onInputChange={(event, newInputValue, reason) => {
        // Sólo cuando el usuario escribe (no en clear / reset internos)
        if (reason === "input") {
          onChange && onChange(event, newInputValue, name);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          autoComplete="off"
          inputProps={{ ...params.inputProps, maxLength }}
          error={error}
          helperText={helperText}
        />
      )}
      sx={{ width: width, height: "6.3vh" }}
      disabled={disabled}
    />
  );
};

export default AutoCompleteTools;
